import { isValidCpfCnpj, normalizeCpfCnpj } from '@/shared/utils/documentValidation';

import type { PhoneConflictData, ValidatePhoneConflictInput } from '../types';

const DESCRICAO_POR_TELEFONE = 'Este telefone já possui uma negociação ativa na mesma empresa.';
const DESCRICAO_POR_CPF = 'Este CPF/CNPJ já possui uma negociação ativa neste workspace.';

/**
 * O que vai para a checagem de negociação aberta: o WhatsApp sempre; o CPF/CNPJ só quando
 * válido, e só com dígitos. Sem CPF o back checa só o WhatsApp, como antes.
 *
 * @example
 * montarChecagemConflito('+5511999998888', '529.982.247-25'); // { phone, cpfCnpj: '52998224725' }
 */
export function montarChecagemConflito(
  phone: string,
  cpfCnpjDigitado: string,
): ValidatePhoneConflictInput {
  const cpfCnpj = isValidCpfCnpj(cpfCnpjDigitado) ? normalizeCpfCnpj(cpfCnpjDigitado) : undefined;
  return cpfCnpj ? { phone, cpfCnpj } : { phone };
}

/**
 * Identifica uma checagem: mudou o telefone ou o CPF, a resposta anterior não vale mais.
 *
 * @example
 * chaveDaChecagem({ phone: '+55 11 99999-8888', cpfCnpj: '52998224725' }); // '5511999998888|52998224725'
 */
export function chaveDaChecagem(input: ValidatePhoneConflictInput): string {
  return `${input.phone.replace(/\D/g, '')}|${input.cpfCnpj ?? ''}`;
}

/**
 * Subtítulo do modal de negociação em andamento conforme o dado que achou a negociação.
 * Back anterior ao `matchedBy` não manda o campo: era sempre o telefone.
 *
 * @example
 * descricaoDoConflito('CPF'); // 'Este CPF/CNPJ já possui uma negociação ativa neste workspace.'
 */
export function descricaoDoConflito(matchedBy: PhoneConflictData['matchedBy']): string {
  return matchedBy === 'CPF' ? DESCRICAO_POR_CPF : DESCRICAO_POR_TELEFONE;
}
